import script from "./AnnounceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnounceDetail.vue?vue&type=script&setup=true&lang=js"

import "./AnnounceDetail.vue?vue&type=style&index=0&id=7c70a9e3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c70a9e3"]])

export default __exports__